import { render } from "./EmpresaForm.vue?vue&type=template&id=3c96b0ea"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"
script.render = render

export default script